// Polyfills
import URLSearchParams from '@ungap/url-search-params' // url search parametr API polyfill
import 'element-closest-polyfill'

// jQuery
import './jquery-loader'

// jQuery Validator (Umbraco Forms)
import 'jquery-validation'
import 'jquery-validation-unobtrusive'
import 'jquery-ajax-unobtrusive'

// Modules
import initDeviceDetection from './modules/device-detection'
import initMastHeadVimeo from './modules/masthead-vimeo'
import './modules/scroll-reveal'
import './modules/tracking'
import 'swiped-events'

// Components
import './components/background-video'
import './components/careers'
import './components/career-filter-dropdown'
import './components/carousel'
import './components/cookie-bar'
import './components/filter'
import './components/footer'
import './components/forms'
import './components/navigation'
import './components/split-background'
import './components/split-multiple-backgrounds'
import { initSwiperCarousels } from './components/swiper-carousels'

// Onload Events
let documentBody = ''
window.onload = (event) => {
  documentBody = document.querySelector('body')
  documentBody.classList.add('content-loaded')
  documentBody.classList.remove('no-js')

  initSwiperCarousels()
  initDeviceDetection()
  initMastHeadVimeo()
}
